<template>
  <BGModal :shown="dialogShown"
           :title="$t('admin_notification_template.edit_title')">
    <template #content>
      <v-container class="edit-notification-template-content" fluid v-if="template">
        <v-form ref="emailTemplateForm">
          <v-row>
            <v-col>
              <v-text-field readonly
                            :label="$t('admin_notification_template.type')"
                            :value="$t(`email_template_types.${template.type}`)"></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <v-text-field outlined
                            :rules="requiredRules"
                            :label="$t('admin_notification_template.email_subject')"
                            v-model="template.email_subject"></v-text-field>
            </v-col>
          </v-row>
          <v-row class="pt-0">
            <v-col>
              <v-input :rules="requiredRules"
                       hide-details="auto"
                       v-model="template.email_content">
                <v-container fluid class="flex-column">
                  <legend class="v-label theme--light">{{ $t('admin_notification_template.email_content') }}</legend>
                  <TinyMceEditor v-model="template.email_content"
                                 allow-all-style></TinyMceEditor>
                </v-container>
              </v-input>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <v-checkbox :label="$t('admin_notification_template.push_notification_enabled')"
                          v-model="template.push_notification_enabled">
              </v-checkbox>
            </v-col>
          </v-row>
          <v-row v-if="template.push_notification_enabled">
            <v-col>
              <v-text-field outlined
                            :rules="requiredRules"
                            :label="$t('admin_notification_template.push_notification_content')"
                            v-model="template.push_notification_content"></v-text-field>
            </v-col>
          </v-row>
        </v-form>
      </v-container>
    </template>
    <template #footer>
      <v-row no-gutters>
        <v-btn @click="cancel"
               class="mr-3"
               depressed
               large>
          {{ $t('cancel') }}
        </v-btn>
        <v-spacer></v-spacer>
        <v-btn color="primary"
               depressed
               large
               :disabled="!templateChanged"
               @click="$refs.emailTemplateForm.validate() && saveEmailTemplate()">
          {{ $t('save') }}
          <v-icon right>fas fa-check</v-icon>
        </v-btn>
      </v-row>
    </template>
  </BGModal>
</template>
<script>
import BGModal from "@/components/BGModal";
import {computed, ref, watch} from "@vue/composition-api";
import TinyMceEditor from "@/components/TinyMceEditor";
import _ from "lodash";

export default {
  name: 'EditSasvEmailTemplateModal',
  components: {TinyMceEditor, BGModal},
  props: {
    shown: Boolean,
    emailTemplateId: String,
  },
  setup(props, {root, emit}) {
    const dialogShown = ref(props.shown);

    const tabIndex = ref(0);

    // Init
    watch(() => props.shown, async (newValue, oldValue) => {
      if (newValue !== oldValue) {
        dialogShown.value = newValue;

        if (newValue) {
          tabIndex.value = 0;
          getEmailTemplate();
        }
      }

      tabIndex.value = 0;
    });
    const cancel = function () {
      emit('cancel');
    };
    const getEmailTemplate = function () {
      root.$callAPI('sasv/admin/email_template/', {id: props.emailTemplateId}, function (response) {
        template.value = response.body.template;
        originalTemplate.value = {...response.body.template};
      });
    }

    // Info
    const template = ref(null);
    const originalTemplate = ref(null);
    const templateChanged = computed(() => {
      return !_.isEqual(template.value, originalTemplate.value);
    })

    const requiredRules = ref([
      value => !!value || root.$t('register.required_fields'),
    ]);

    const saveEmailTemplate = function () {
      root.$callAPI('sasv/admin/email_template/set/', {
        ...template.value,
      }, () => {
        root.$showAlertMessage('Info Saved');
        getEmailTemplate();
      })
    }

    return {
      dialogShown,
      tabIndex,

      cancel,

      // Info
      template,
      templateChanged,

      requiredRules,

      saveEmailTemplate,
    }
  }
}
</script>

<style lang="less">
.edit-emailTemplate-content {
  display: flex;
  height: 100%;
  flex-direction: column;
}
</style>
